const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'See Sight Tours',
  email: 'info@seesight-tours.com',
  telePhone: '+1-289-271-9767',
  url: 'https://www.seesight-tours.com/',
  Image: '/vertical-seesight-logo.png',
  Logo: '/vertical-seesight-logo.png',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '5779 Desson Avenue Niagara Falls',
    addressLocality: 'Ontario',
    addressRegion: 'Canada',
    postalCode: 'L2G 3T5'
  },
  sameAs: [
    'https://www.instagram.com/seesighttours',
    'https://ca.pinterest.com/seesighttours',
    'https://www.tiktok.com/@seesighttours',
    'https://www.facebook.com/seesighttours',
    'https://www.linkedin.com/company/see-sight-tours-ca/',
    'https://x.com/seesighttours',
    'https://www.youtube.com/@seesight-tours'
  ],
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.9',
    ratingCount: '5300',
    bestRating: '5',
    worstRating: '1'
  }
};
export const WebsiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'See Sight Tours',
  alternateName: 'See Sight Tours',
  url: 'https://www.seesight-tours.com/'
};
export default organizationSchema;
